import React, { useState } from 'react';
import './SupportModal.scss';
import { Col, Row } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import { formatPhoneNumber } from '../Helpers/Conversion';

const useStyles = makeStyles(theme => ({
    blueText: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        overflowWrap: 'break-word',
        fontSize: '14px',

    },
    borderBlue: {
        borderLeft: `3.5px solid ${theme.palette.primary.main}!important`,
    },
    imgColor: {
        color: theme.palette.primary.main
    }
}));

export default function SupportModal(props) {
    const [tab, setTab] = useState([props.isAIP, props.isRIC, false]);
    const classes = useStyles();
    const [error, setError] = useState([false, false])

    const openTab = (tabName) => {
        let tabArray = [];
        switch (tabName) {
            case 'RIC':
                tabArray = [true, false, false]
                break;
            case 'UW':
                tabArray = [false, false, true]
                break;
            case 'AIP':
            default:
                tabArray = [false, true, false]
                break;
        }
        setTab([...tabArray]);
    }

    const getDetailsForTab = (tab) => {
        let name, src, designation, index, errorOfTab, email, contact, description, link,contactCell,shortName;
        switch (tab) {
            case 'RIC':
                name = props.userData.iscName;
                index = 0;
                src = props.userData.ricProfileImageURL;
                designation = 'Regional Insurance Consultant';
                errorOfTab = error[0];
                email = props.userData.ricEmail;
                contact = formatPhoneNumber(props.userData.ricWorkPhone);
                description = props.userData.ricBiography;
                link = props.userData.ricCalendlyURL;                
                break;
            case 'UW':
            default:
                name = props.userData.assignedUnderwritingFullName;
                src = props.userData.assignedUnderwritingProfileImageURL;
                designation = 'General Underwriting Questions';
                errorOfTab = true;
                description = props.userData.assignedUnderwritingBio;
                email = props.userData.assignedUnderwritingEmail;
                contact = formatPhoneNumber(props.userData.assignedUnderwritingWorkPhone);
                break;
        }
        return { name, index, src, designation, errorOfTab, email, contact, description, link , contactCell, shortName }
    }

    const setErrorForImage = (index) => {
        let errorIndex = error;
        errorIndex[index] = true;
        setError([...errorIndex])
    }

    const viewTabContent = (tab) => {
        let details = getDetailsForTab(tab);
        return (
            <div>
                <Row className='header-design'>
                    <h3 className='w-100 ml-4 pl-1'>{details.name}</h3>
                    <br />
                    <div className='w-100'>
                        <span className='ml-4 pl-1 mb-4 float-left'>
                            <b>{details.designation}</b>
                        </span>
                        {
                            !details.src || details.errorOfTab ?
                                <div className={`image px-3 padding-y ${classes.imgColor}`}>{props.getAltText(details.name)}</div>
                                :
                                <img className={`float-right image ${classes.imgColor}`} src={details.src} onError={() => setErrorForImage(details.index)} alt="" />
                        }
                    </div>
                </Row>
                <Row>
                    <Col md={7} className='mt-4 ml-3 margin-col height-class'>
                        <p className='title-grey' dangerouslySetInnerHTML={{ __html: details.description }}></p>
                    </Col>
                    <Col className='left-column' md={4}>
                        <p className='title-grey'> Contact</p>
                        {details.email && (
                            <div>
                                <p className='title-grey mt-2 mb-1'>Email</p>
                                <a className={classes.blueText} href={`mailto:${details.email}`}>{details.email}</a>
                            </div>
                        )}
                        {details.contact && (
                            <div>
                                <p className='title-grey mt-2 mb-1'>Phone</p>
                                <a className={classes.blueText} href={`tel:${details.contact}`}>{details.contact} </a>
                            </div>
                        )}
                        {details.contactCell &&
                            <div>
                                <p className='title-grey mt-2 mb-1'>Cell</p>
                                <a className={classes.blueText} href={`tel:${details.contactCell}`}>{details.contactCell} </a>
                            </div>
                        }
                        {details.link &&
                            <div>
                                <p className='title-grey mt-2 mb-1'>Schedule an Appointment</p>
                                <a className={classes.blueText} href={details.link}>{details.link}</a>
                            </div>
                        }
                    </Col>
                </Row>
            </div>
        )
    }

    const viewTabs = (tabName) => {
        let details = getDetailsForTab(tabName);
        return (
            <div>
                <span className={`float-left ${details.shortName ? 'mb-5': ''} `}>
                    {
                        !details.src || details.errorOfTab ?
                            <div className={`small-image padding-y-small ${classes.imgColor}`}>{props.getAltText(details.name)}</div>
                            :
                            <img className={`float-right small-image ${classes.imgColor}`} src={details.src} onError={() => setErrorForImage(details.index)} alt="" />
                    }
                </span>
                <div>
                    <span className='ml-2 font-weight-bold'>
                        {details.shortName || details.name}
                    </span>
                    <br />
                    <div className='tab-text pl-5 ml-1'>
                        {details.designation}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Row className='no-gutters z-index-row'>
            <Col className="tab mt-0" md={3}>
                <h3 className='mt-4 ml-3 title-grey'>Contact Covr</h3>
                <h5 className='mt-4 ml-3 pt-1 title-grey'>Your Team</h5>
                <button className={`${tab[0] ? `active ${classes.borderBlue}` : ''} tablinks button p-3`} onClick={() => openTab('RIC')}>
                    {viewTabs('RIC')}
                </button>
                {(props.userData.assignedUnderwritingFullName) && (
                    <button className={`${tab[2] ? `active ${classes.borderBlue}` : ''} tablinks button p-3`} onClick={() => openTab('UW')} >{viewTabs('UW')}</button>
                )}
            </Col>
            <Col md={9}>
                <div id="RIC" className={`${tab[0] ? 'd-block' : 'd-none'} tabcontent w-100`}>
                    {viewTabContent('RIC')}
                </div>
                {(props.userData.assignedUnderwritingFullName) && (
                    <div id="UW" className={`${tab[2] ? 'd-block' : 'd-none'} tabcontent w-100`}>
                    {viewTabContent('UW')}
                    </div>
                )}
            </Col>
        </Row>
    )
}



// WEBPACK FOOTER //
// ./src/components/Layout/SupportModal.js